<template>
	<div class="login_code">
		<LoginHeader title="输入验证码">
			<template #desc>
				<p>
					验证码已发送至
					<span style="color:#1F2329;">{{ mobile | mobileFormat }}</span>
				</p>
			</template>
		</LoginHeader>
		<div class="main">
			<van-password-input
				:value="smsCode"
				:mask="false"
				gutter="15px"
				:focused="showKeyboard"
				@focus="clickCodeInput"
			/>
			<van-number-keyboard v-model="smsCode" maxlength="6" :show="showKeyboard" @blur="showKeyboard = false" />
		</div>
		<div class="text-center">
			<van-button v-if="isCountDown" class="code_btn" color="#EFF0F1" plain>
				<van-count-down :time="60 * 1000" format="重新获取 (ss)" @finish="isCountDown = false" />
			</van-button>
			<van-button
				v-else
				class="code_btn"
				:loading="loading"
				:loading-text="loadingText"
				type="primary"
				plain
				@click="clickSendSmsCode"
			>
				重新获取
			</van-button>
		</div>
	</div>
</template>

<script>
	import LoginHeader from './login-header.vue'
	import { mapMutations, mapGetters } from 'vuex'
	export default {
		name: 'login-mobile',
		props: ['mobile'],
		components: {
			LoginHeader
		},
		data: () => ({
			loading: true,
			loadingText: '加载中...',
			smsCode: '',
			isCountDown: false,
			showKeyboard: false
		}),
		filters: {
			mobileFormat (val) {
				if (!val) return val
				if (typeof val !== 'string') return val
				return `${val.substring(0, 3)} ${val.substring(3, 7)} ${val.substring(7)}`
			}
		},
		computed: {
			...mapGetters('router', ['getRedirect']),
			...mapGetters('account', ['getOpenid', 'getUnionid']),
		},
		watch: {
			smsCode (val) {
				if (val.length === 6) {
					this.showKeyboard = false
					this.login()
				}
			}
		},
		created () {
			this.mobile && this.clickSendSmsCode()
		},
		methods: {
			...mapMutations('account', ['SET_TOKEN', 'SET_PATIENT_ID', 'SET_PATIENT_INFO']),
			clickCodeInput () {
				if (!this.loading) {
					this.showKeyboard = true
				}
			},
			// 点击获取验证码
			clickSendSmsCode () {
				this.loading = true
				this.loadingText = '获取中...'

				this.$api.account.sendSmsCode(this.mobile).then(res => {
					this.loading = false
					if (!res.code) this.isCountDown = true
				}).catch(() => this.loading = false)
			},
			// 登录
			login () {
				this.loading = true
				this.loadingText = '登录中...'
				this.$api.account.valCodeAndPhone({
					mobile: this.mobile,
					smsCode: this.smsCode,
					openid: this.getOpenid,
					unionId: this.getUnionid
				}).then(res => {
					this.loading = false
					if (!res.code) {
						if (!res.data.patientId) {
							if (
								!this.getRedirect ||
								(
									!this.getRedirect.startsWith('/dpbind/create/')
									&& !this.getRedirect.startsWith('/dpbind/list/')
									&& !this.getRedirect.startsWith('/jointManage/invite/')
									&& !this.getRedirect.startsWith('/jointManage/result/')
								)
							) {
								this.$dialog.alert({
									title: '温馨提示',
									message: '请先与医生进行绑定认证'
								})
								return
							}
						}else{
							this.SET_PATIENT_ID(res.data.patientId)
							this.SET_PATIENT_INFO({})
						}
						this.SET_TOKEN(res.data.token)

						// 重新登录 并调回原来的地址
						if (this.$route.query.type === 'again' && this.getRedirect) {
							this.$router.replace(this.getRedirect)
							window.sessionStorage.removeItem('redirect')
							return
						}
						this.$router.replace('/main/home')
					}
				}).catch(() => this.loading = false)
			},
		}
	}
</script>

<style scoped lang="less">
	.login_code {
		padding: 0 60px;
		.main {
			padding-top: 52px;
			margin-bottom: 140px;
		}
		.code_btn { min-width: 279px; }
	}
</style>
<style lang="less">
	.login_code {
		.van-password-input {
			margin: 0;
			.van-password-input__security{
				.van-password-input__item {
					border-bottom: 2px solid #1F2329;
				}
				&::after { display: none; }
			}
		}
		.van-count-down {
			white-space: nowrap;
			color: #BBBFC4;
		}
	}
</style>
